import { Popover } from 'antd';
import React, { ReactNode } from 'react';
import styles from "@/styles/checkout/common.module.scss";

interface HoverIconSwitchProps {
  IconOne: ReactNode;
  IconTwo: ReactNode;
  hoverContent?: string;
}

const HoverIconSwitch: React.FC<HoverIconSwitchProps> = ({ IconOne, IconTwo, hoverContent }) => {
  return hoverContent ? (
    <Popover placement="top" content={hoverContent}>
      <div className={styles['hoverIconSwitch']}>
        <div className={styles['iconOne']}>{IconOne}</div>
        <div className={styles['iconTwo']}>{IconTwo}</div>
      </div>
    </Popover>
  ) : (
    <div className={styles['hoverIconSwitch']}>
      <div className={styles['iconOne']}>{IconOne}</div>
      <div className={styles['iconTwo']}>{IconTwo}</div>
    </div>
  );
};

export default HoverIconSwitch;
